export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  ACCOUNT: { CREATE: "/accounts/e", LIST: "/accounts", EDIT: "/accounts/:id/e", VIEW: "/accounts/:id" },
  CONTACT: { CREATE: "/contacts/e", LIST: "/contacts", EDIT: "/contacts/:id/e", VIEW: "/contacts/:id" },
  COMMISSION: { CREATE: "/commissions/e", LIST: "/commissions", EDIT: "/commissions/:id/e", VIEW: "/commissions/:id" },
  LEAD: { CREATE: "/leads/e", LIST: "/leads", EDIT: "/leads/:id/e", VIEW: "/leads/:id" },
  USER: { CREATE: "/users/e", LIST: "/users", EDIT: "/users/:id/e", VIEW: "/users/:id" },
  USER_TRACKING: "/user_tracking",
  PROJECT: { LIST: "/projects", DASHBOARD: "/projects/dashboard" },
  HANDOVER: { CREATE: "/handovers/e", LIST: "/handovers", EDIT: "/handovers/:id/e", VIEW: "/handovers/:id" },
  PRODUCT: { CREATE: "/products/e", LIST: "/products", EDIT: "/products/:id/e", VIEW: "/products/:id" },
  BRAND: { CREATE: "/brands/e", LIST: "/brands", EDIT: "/brands/:id/e", VIEW: "/brands/:id" },
  BOM: { CREATE: "/boms/e", LIST: "/boms", EDIT: "/boms/:id/e", VIEW: "/boms/:id" },
  QUOTATION: { CREATE: "/quotations/e", LIST: "/quotations", EDIT: "/quotations/:id/e", VIEW: "/quotations/:id" },
  REPORT: { LIST: "/reports", VIEW: "/reports/:id" },
  // Support Period Updates By Farhan Khan on 20-March-2026
  CATEGORY: { CREATE: "/categories/e", LIST: "/categories", EDIT: "/categories/:id/e", VIEW: "/categories/:id" },
  SPECIFICATION: { CREATE: "/specifications/e", LIST: "/specifications", EDIT: "/specifications/:id/e", VIEW: "/specifications/:id" },
  //End Here Farhan Khan on 20-March-2026
  DASHBOARD: "/dashboards",
  BACKUP: "/backups",
  PROFILE: "/profile",
  ENQUIRY_FORM: "/enquiry_form",
  SERVICE_FORM: "/service_form",
  SETTINGS: "/settings",
}